import Image from '@/components/Image';
import Link from '@/components/Link';

export default function PostAuthor({
  trainer: {
    title,
    featuredImage,
    uri,
  },
  position,
}) {
  return (
    <Link href={uri} className="flex items-center space-x-4">
      <div className="w-12 h-12">
        <Image
          alt={title}
          src={featuredImage.node.sourceUrl}
          className="block rounded-full w-12 h-12"
        />
      </div>
      <div className="flex flex-col space-y-2">
        <h4 className="font-semibold text-base m-0 leading-none">
          {title}
        </h4>
        <div className="text-gray-500 leading-none text-sm">
          {position}
        </div>
      </div>
    </Link>
  );
}
